import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const initialState = {
  consents: {},
  result: {},
  processId: null,
  contractDocumentUrl: null
}

const ActivationSubmitModule = {
  namespaced: true,
  state: initialState,
  getters: {
    deferredResponse: (state) => {
      return state.result?.deferredIdentificationResponse
    },
    getSuccessIdent: (state, getters, rootState, rootGetters) => {
      if (getters.deferredResponse?.identProvider === 'Deutsche_Post') {
        if (rootGetters['activation/personalData/identificationCore'].identMethod === 'video') {
          return 'videoIdentPost'
        }
        if (rootGetters['activation/personalData/identificationCore'].identMethod === 'store') {
          return 'postIdent'
        }
      }
      if (getters.deferredResponse?.identProvider === 'WebId') {
        return 'videoIdentWeb'
      }
      return null
    },
    getSuccessUrl: (state, getters) => {
      return getters.deferredResponse?.url || null
    },
    consents: (state) => {
      return state.consents
    },
    processId: (state) => {
      return state.processId
    },
    contractDocumentUrl: (state) => {
      return state.contractDocumentUrl
    },
    activationInputCore: (state, getters, rootState, rootGetters) => {
      return {
        customer: {
          address: rootGetters['activation/personalData/address'],
          ...rootGetters['activation/personalData/personal'],
          ...rootGetters['activation/personalData/additional']
        },
        brand: rootGetters.brand,
        deferredIdentification: rootGetters['activation/personalData/identificationCore'],
        identification: null, // 'IdentificationInput',
        mobileNumberPortability: null, // 'MobileNumberPortabilityInput',
        msisdn: rootGetters['activation/info/msisdn'],
        payment: rootGetters['activation/payment/getPayment'],
        preactiveCardAuthentication: {
          activationCode: rootGetters['activation/info/activationCode'],
          pPlusToken: rootGetters['activation/info/pPlusToken']
        } // 'PreactiveCardAuthenticationInput',
      }
    },
    referFriendInput: (state, getters, rootState, rootGetters) => {
      if (rootGetters['friendNotification/existingCustomerMsisdn']) {
        return {
          referFriend: {
            existingCustomerMsisdn: rootGetters['friendNotification/existingCustomerMsisdn'],
            newCustomerMsisdn: rootGetters['activation/info/msisdn']
          }
        }
      } else {
        return null
      }
    }
  },
  mutations: {
    storeResult: (state, result) => {
      state.result = result
    },
    storeProcessId: (state, processId) => {
      state.processId = processId
    },
    storeConsents: (state, consents) => {
      state.consents = consents
    },
    storeContractDocumentUrl: (state, contractDocumentUrl) => {
      state.contractDocumentUrl = contractDocumentUrl
    }
  },
  actions: {
    async activationInitiate ({ commit, state, getters, rootGetters }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`
          mutation activation ($activationInput: ActivationInput!) {
            activationInitiate (activationInput: $activationInput){
              contractDocumentUrl
              processId
            }
          }`,
        variables: {
          activationInput: {
            ...getters.activationInputCore,
            topup: {
              ...rootGetters['activation/topUp/topUpCore'],
              singleTopupAmount: rootGetters['activation/topUp/singleTopUpCore']
            },
            product: {
              tariffIdentifier: rootGetters['activation/info/tariffIdentifier'],
              promotions: null,
              tariffotions: rootGetters['activation/tariffOptions/tariffOptionIds'],
              article: null
            },
            orderContext: {
              market: rootGetters['activation/info/market']
            }
          }
        }
      }).then((response) => {
        commit('storeProcessId', response.data.activationInitiate.processId)
        commit('storeContractDocumentUrl', response.data.activationInitiate.contractDocumentUrl)
        return response.data.activationInitiate.contractDocumentUrl
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async activationConfirm ({ commit, state, getters, rootGetters }, { nextStep = 'success', consents }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`
          mutation activation ($activationConfirmInput: ActivationConfirmInput!) {
            activationConfirm (activationConfirm: $activationConfirmInput){
              contractId,
              customerId,
              deferredIdentificationResponse {
                actionID,
                identProvider,
                url
              }
            }
          }`,
        variables: {
          activationConfirmInput: {
            brand: rootGetters.brand,
            msisdn: rootGetters['activation/info/msisdn'],
            processId: getters.processId,
            consent: {
              adConsent: consents.contact,
              passData: consents.exchange,
              agb: consents.agb,
              contractTermsVersion: consents.contractTermsVersion
            }
          }
        }
      }).then((response) => {
        commit('storeConsents', consents)
        commit('storeResult', response.data.activationConfirm)
        commit('Transaction/removeTransactionId', 'activation', { root: true })
        commit('activation/goToStep', nextStep, { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  }
}

export {
  ActivationSubmitModule
}
